import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  environment: boolean = false;
  environmentName: string = '';
  url: string;
  defaultModule: any;
  decryptionKey: any;
  constructor(private http: HttpClient) {
    this.environment = environment.production;
    this.environmentName = environment.environmentName;
  }
  getCompanyList() {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/companies")
  }
  getAllPlantsRelatedToCompany(company_id) {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/plants?company_id=" + company_id)
  }
  getPlantData(business_unit_id: any, company_id) {
    if (business_unit_id) {
      return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/plants?business_unit_id=" + business_unit_id)
    }
    if (company_id) {
      return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/plants?company_id=" + company_id)
    }
    if (!company_id && !business_unit_id) {
      return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/plants")
    }
  }
  getApplicationTypes() {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/application_types")
  }
  getApplications(application_type_id) {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/application_groups?application_type_id=" + application_type_id)
  }
  getModules(application_group_id) {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/applications?application_group_id=" + application_group_id)
  }
  getSubModules(application_id) {
    return this.http.get(sessionStorage.getItem('apiUrl') + 'config_portal/' + sessionStorage.getItem('region') + "/sub_applications?application_id=" + application_id)
  }
  readConfigurationsData() {
    const fileName = this.environmentName == 'dev' ? 'application-configurations.json' : 'application-configurations-' + this.environmentName + '.json';
    return this.http.get('assets/json/' + fileName).pipe(map(
      (data: any) => {
        sessionStorage.setItem('modules', JSON.stringify(data['modules']));
        this.decryptionKey = data['imageDecryptionKey'];
        this.defaultModule = data['defaultModule'];
        this.url = data['url'];
        return data;
      }
    ));
  }

  readModuleConfigurationsData(module: string) {
    const fileName = this.environmentName == 'dev' ? module + '-configurations.json' : module + '-configurations-' + this.environmentName + '.json';
    return this.http.get('assets/json/' + fileName).pipe(map(
      data => {
        return data;
      }
    ));
  }
  newUserActivity(data) {
    let url = sessionStorage.getItem('apiUrl') + 'activity_monitoring/user_click_view/';
    return this.http.post(url, data).pipe(map(
      data => {
        return data;
      }
    ));
  }
  navigateToModule(module) {
    // let url = 'http://localhost:4500/' + module + '/?userData=' + unescape(encodeURIComponent(window.btoa(sessionStorage.getItem('userData')))) + '&autoLogin=' + unescape(encodeURIComponent(window.btoa(sessionStorage.getItem('token'))));
    let url = this.url + 'sc/' + module + '/?userData=' + unescape(encodeURIComponent(window.btoa(sessionStorage.getItem('userData')))) + '&autoLogin=' + unescape(encodeURIComponent(window.btoa(sessionStorage.getItem('token'))))
    window.open(url);
  }
  getSchemaFile(fileName) {
    return this.http.get("assets/json/schemas/" + fileName);
  }
  getJsonFile(fileName) {
    return this.http.get("assets/json/" + fileName);
  }
  resizeDatatable() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }
}
